/**
 * index.ts - General preference modules
 * 
 * CHANGE HISTORY:
 * - 251023_1854 [pending] danielbeer: Initial creation
 */

export { applicationModule } from './application';

import { applicationModule } from './application';

export const generalModules = [
  applicationModule
];

export default generalModules;
